export const VERIFY_EMPLOYEE = '@REGISTER_EMPLOYEE/VERIFY_EMPLOYEE'
export const VERIFY_EMPLOYEE_SUCCESS = '@REGISTER_EMPLOYEE/VERIFY_EMPLOYEE_SUCCESS'
export const VERIFY_EMPLOYEE_ERROR = '@REGISTER_EMPLOYEE/VERIFY_EMPLOYEE_ERROR'

export const REGISTER_EMPLOYEE = '@REGISTER_EMPLOYEE/REGISTER_EMPLOYEE'
export const REGISTER_EMPLOYEE_SUCCESS = '@REGISTER_EMPLOYEE/REGISTER_EMPLOYEE_SUCCESS'
export const REGISTER_EMPLOYEE_ERROR = '@REGISTER_EMPLOYEE/REGISTER_EMPLOYEE_ERROR'
